import React, { useEffect, useState } from "react";
import axios from "axios";
import apiConfig from "../../../../apiConfig";
import { toast } from "react-toastify";

function SellerCommission() {

    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [products, setProducts] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");

    const [commissionType, setCommissionType] = useState("percentage");
    const [commissionValue, setCommissionValue] = useState("");

    const [sellers, setSellers] = useState([]);
    const [selectedSeller, setSelectedSeller] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);

    const [commissions, setCommissions] = useState([]);
    const token = localStorage.getItem("authToken");

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${apiConfig.baseUrl}${apiConfig.getCategory}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            setCategories(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSubcategories = async (categoryId) => {
        try {
            if (categoryId) {
                const response = await axios.get(
                    `${apiConfig.baseUrl}${apiConfig.getSubCategory}${categoryId}`
                );
                setSubcategories(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchProducts = async (subcategoryId) => {
        try {
            const res = await axios.get(`${apiConfig.baseUrl}${apiConfig.getProducts}${subcategoryId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProducts(res.data.products || res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCommissions = async () => {
        try {
            const res = await axios.get(`${apiConfig.baseUrl}${apiConfig.getAllCommissions}`);
            setCommissions(res.data.commissions);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSellers = async () => {
        try {
            const res = await axios.get(
                `${apiConfig.baseUrl}${apiConfig.GetAllSeller}`
            );
            setSellers(res.data.data || []);
        } catch (error) {
        }
    };


    useEffect(() => {
        fetchCategories();
        fetchCommissions();
        fetchSellers();
    }, []);

    const handleCategoryChange = (id) => {
        setSelectedCategory(id);
        setSelectedSubcategory("");
        setSelectedProduct("");
        fetchSubcategories(id);
    };

    const handleSubcategoryChange = (id) => {
        setSelectedSubcategory(id);
        setSelectedProduct("");
        fetchProducts(id);
    };

    const getLevel = () => {
        if (selectedProduct) return "product";
        if (selectedSubcategory) return "subcategory";
        if (selectedCategory) return "category";
        return "";
    };

    const handleSubmit = async () => {

        const level = getLevel();
        const referenceValue =
            selectedProduct ||
            selectedSubcategory ||
            selectedCategory;

        if (!level || !commissionValue) {
            toast.info("Please fill all fields");
            return;
        }

        try {
            await axios.post(`${apiConfig.baseUrl}${apiConfig.createCommission}`, {
                level,
                sellerId: selectedSeller || null,
                referenceValue,
                commissionType,
                commissionValue
            });
            toast.success("Commission Saved Successfully");
            fetchCommissions();
            setSelectedCategory("");
            setSelectedSubcategory("");
            setSelectedProduct("");
            setCommissionType("percentage");
            setCommissionValue("");
            setSelectedSeller("");
        } catch (error) {
            console.error(error);
        }
    };

    const handleDelete = async (id) => {
        console.log("Delete commission with ID:", id);
        try {
            await axios.delete(`${apiConfig.baseUrl}${apiConfig.DeleteCommission}${id}`);
            toast.success("Commission deleted successfully");
            fetchCommissions();
        }
        catch (error) {
            console.error("Failed to delete commission:", error);
            toast.error("Failed to delete commission");
        }
    }

    const handleUpdate = (item) => {
        setEditId(item);

        setSelectedSeller(item.sellerId || "");

        setCommissionType(item.commissionType);

        setCommissionValue(item.commissionValue);

        // set level reference
        if (item.level === "category") {
            setSelectedCategory(item.referenceValue);
            fetchSubcategories(item.referenceValue);
        }

        if (item.level === "subcategory") {
            setSelectedSubcategory(item.referenceValue);
            fetchProducts(item.referenceValue);
        }
        if (item.level === "product") {
            setSelectedProduct(item.referenceValue);
        }
        setShowModal(true);
    };

    const handleUpdateSubmit = async () => {
        try {
            await axios.put(
                `${apiConfig.baseUrl}${apiConfig.UpdateCommission}${editId}`,
                {
                    commissionType,
                    commissionValue,
                    isActive: true
                }
            );
            toast.success("Commission Updated Successfully");
            setShowModal(false);
            fetchCommissions();

        } catch (error) {
            console.error(error);
            toast.error("Update failed");
        }
    };

    return (
      <div className="container-fluid py-4">
        <h2 className="text-xl  font-semibold mb-4">Seller Commission</h2>

        <div className="row justify-content-center">
          <div className="">
            <div className="card shadow-lg border-0">
              <div className="card-body">
                <div className="row g-3">
                  {/* CATEGORY */}
                  <div className="col-md-4">
                    <label className="form-label">Category</label>
                    <select
                      className="form-select"
                      value={selectedCategory}
                      onChange={(e) => handleCategoryChange(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {categories?.map((cat) => (
                        <option key={cat._id} value={cat._id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* SUBCATEGORY */}

                  <div className="col-md-4">
                    <label className="form-label">Subcategory</label>
                    <select
                      className="form-select"
                      value={selectedSubcategory}
                      onChange={(e) => handleSubcategoryChange(e.target.value)}
                    >
                      <option value="">Select Subcategory</option>
                      {subcategories?.map((sub) => (
                        <option key={sub._id} value={sub._id}>
                          {sub.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Seller</label>
                    <select
                      className="form-select"
                      value={selectedSeller}
                      onChange={(e) => setSelectedSeller(e.target.value)}
                    >
                      <option value="">Global Commission (All Sellers)</option>
                      {sellers?.map((seller) => (
                        <option key={seller._id} value={seller._id}>
                          {seller.sellerId || "-"} - {seller.fullName || "-"}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* PRODUCT */}

                  <div className="col-md-4">
                    <label className="form-label">Product (optional)</label>
                    <select
                      className="form-select"
                      value={selectedProduct}
                      onChange={(e) => setSelectedProduct(e.target.value)}
                    >
                      <option value="">Select Product</option>

                      {products?.map((product) => (
                        <option key={product._id} value={product._id}>
                          {product.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* COMMISSION TYPE */}

                  <div className="col-md-6">
                    <label className="form-label">Commission Type</label>
                    <select
                      className="form-select"
                      value={commissionType}
                      onChange={(e) => setCommissionType(e.target.value)}
                    >
                      <option value="percentage">Percentage</option>
                      <option value="fixed">Fixed</option>
                    </select>
                  </div>

                  {/* VALUE */}

                  <div className="col-md-6">
                    <label className="form-label">Commission Value</label>
                    <input
                      type="number"
                      className="form-control"
                      value={commissionValue}
                      onChange={(e) => setCommissionValue(e.target.value)}
                      placeholder="Enter value"
                    />
                  </div>
                </div>

                <div className="mt-4 text-end">
                  <button
                    className="btn btn-success px-4"
                    onClick={handleSubmit}
                  >
                    Save Commission
                  </button>
                </div>
              </div>
            </div>

            {/* TABLE */}
            <div className="card shadow mt-4">
              <div className="card-header">Commission List</div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Level</th>
                      <th>Reference</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Seller Name</th>
                      <th>Shop Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {commissions?.map((item) => (
                      <tr key={item._id}>
                        <td>{item.level}</td>
                        <td>{item.referenceValue}</td>
                        <td>{item.commissionType}</td>
                        <td>{item.commissionValue}</td>
                        <td>
                          {item.sellerFullName ? item.sellerFullName : "-"}
                        </td>
                        <td>
                          {item?.sellerShopName ? item?.sellerShopName : "-"}
                        </td>
                        <td className="d-flex gap-2 justify-content-center align-items-center">
                          <button
                            onClick={() => handleDelete(item._id)}
                            className="btn btn-sm btn-danger"
                          >
                            Delete
                          </button>
                          <button
                            onClick={() => handleUpdate(item._id)}
                            className="btn btn-sm btn-warning ms-2"
                          >
                            Update
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {showModal && (
          <>
            {/* BACKDROP */}
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"></div>

            {/* MODAL */}
            <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
              <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl animate-fadeIn">
                {/* HEADER */}
                <div className="flex justify-between items-center border-b px-6 py-4">
                  <h2 className="text-lg font-semibold text-gray-800">
                    Update Commission
                  </h2>

                  <button
                    onClick={() => setShowModal(false)}
                    className="text-gray-500 hover:text-gray-800 text-xl"
                  >
                    ✕
                  </button>
                </div>

                {/* BODY */}
                <div className="p-6 space-y-4">
                  {/* Commission Type */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Commission Type
                    </label>

                    <select
                      value={commissionType}
                      onChange={(e) => setCommissionType(e.target.value)}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:outline-none"
                    >
                      <option value="percentage">Percentage</option>
                      <option value="fixed">Fixed</option>
                    </select>
                  </div>

                  {/* Commission Value */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Commission Value
                    </label>

                    <input
                      type="number"
                      value={commissionValue}
                      onChange={(e) => setCommissionValue(e.target.value)}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-green-500 focus:outline-none"
                      placeholder="Enter value"
                    />
                  </div>
                </div>

                {/* FOOTER */}
                <div className="flex justify-end gap-3 border-t px-6 py-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleUpdateSubmit}
                    className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
                  >
                    Update Commission
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
}

export default SellerCommission;